import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Row, Col } from 'react-bootstrap';
import PricingPageStyle from './pricing-page.module.scss';

const MonthlyPricing = () => (
  <StaticQuery
    query={graphql`
      query MonthlyPricingDesktop {
        contentfulPricingPlansAssemblyPage {
          basicMonthlyPricing {
            monthlySetupFee
            monthlySupportFee
            activeFeatures {
              json
            }
            inactiveFeatures {
              json
            }
            addOnFeatures {
              json
            }
            activeSupport {
              json
            }
            inactiveSupport {
              json
            }
          }
          midLevelMonthlyPricing {
            monthlySetupFee
            monthlySupportFee
            activeFeatures {
              json
            }
            inactiveFeatures {
              json
            }
            addOnFeatures {
              json
            }
            activeSupport {
              json
            }
          }
          premiumMonthlyPricing {
            monthlySetupFee
            monthlySupportFee
            activeFeatures {
              json
            }
            inactiveFeatures {
              json
            }
            addOnFeatures {
              json
            }
            activeSupport {
              json
            }
            inactiveSupport {
              json
            }
          }
        }
      }
    `}
    render={(data) => (
      <Row className={PricingPageStyle.monthlyPricing}>
        <Col md={4} className={PricingPageStyle.basicPlanColDesktop}>
          <div className={PricingPageStyle.basicPlanDesktop}>
            {/* Basic Pricing */}
            <h3>Starter</h3>
            <h4>
              {
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .monthlySupportFee
              }
            </h4>
            <p>
              {
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .monthlySetupFee
              }
            </p>
            {/* Starter Checkout */}
            <a
              href='https://app.firststringdigital.com/starter-monthly'
              className={PricingPageStyle.choosePlanBtn1}
            >
              Let's Get Started
            </a>

            {/* Basic Active Features */}
            <div className={PricingPageStyle.activeFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .activeFeatures.json
              )}
            </div>

            {/* Basic Inactive Features -- None exist at this tme --  */}
            <div className={PricingPageStyle.inactiveFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .inactiveFeatures.json
              )}
            </div>

            <hr />

            {/* Basic Active Ongoing Support */}
            <div className={PricingPageStyle.activeSupportDiv}>
              <h4>Ongoing Support</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .activeSupport.json
              )}
            </div>

            {/* Basic Inactive Ongoing Support */}
            <div className={PricingPageStyle.inactiveSupportDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .inactiveSupport.json
              )}
            </div>

            <hr />

            {/* Basic Add-on Features */}
            <div className={PricingPageStyle.addonFeaturesDiv}>
              <h4>Add-on Features</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .addOnFeatures.json
              )}
            </div>

            {/* Starter Checkout */}
            <a
              href='https://app.firststringdigital.com/starter-monthly'
              className={PricingPageStyle.choosePlanBtn1}
            >
              Let's Get Started
            </a>
          </div>
        </Col>
        <Col md={4} className={PricingPageStyle.midLevelPlanColDesktop}>
          <div className={PricingPageStyle.midLevelPlanDesktop}>
            {/* Midlevel Pricing */}
            <h3>Entree</h3>
            <h4>
              {
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .monthlySupportFee
              }
            </h4>
            <p>
              {
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .monthlySetupFee
              }
            </p>

            {/* Entree Checkout */}
            <a
              href='https://app.firststringdigital.com/entree-monthly'
              className={PricingPageStyle.choosePlanBtn2}
            >
              Let's Get Started
            </a>

            {/* Mid Active Features */}
            <div className={PricingPageStyle.activeFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .activeFeatures.json
              )}
            </div>

            {/* MidLevel Inactive Features -- None at this time -- */}
            <div className={PricingPageStyle.inactiveFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .inactiveFeatures.json
              )}
            </div>

            <hr />

            {/* Mid Active Ongoing Support */}
            <div className={PricingPageStyle.activeSupportDiv}>
              <h4>Ongoing Support</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .activeSupport.json
              )}
            </div>

            {/* Mid Inactive Ongoing Support */}
            {/* <div className={PricingPageStyle.inactiveSupportDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .inactiveSupport.json
              )}
            </div> */}

            <hr />

            {/* Midlevel Add-on Features */}
            <div className={PricingPageStyle.addonFeaturesDiv}>
              <h4>Add-on Features</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .addOnFeatures.json
              )}
            </div>

            {/* Entree Checkout */}
            <a
              href='https://app.firststringdigital.com/entree-monthly'
              className={PricingPageStyle.choosePlanBtn2}
            >
              Let's Get Started
            </a>
          </div>
        </Col>
        <Col md={4} className={PricingPageStyle.premiumPlanColDesktop}>
          <div className={PricingPageStyle.premiumPlanDesktop}>
            {/* Premium Level Pricing */}
            <h3>Dessert</h3>
            <h4>
              {
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .monthlySupportFee
              }
            </h4>
            <p>
              {
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .monthlySetupFee
              }
            </p>

            {/* Dessert Checkout */}
            <a
              href='https://app.firststringdigital.com/dessert-monthly'
              className={PricingPageStyle.choosePlanBtn3}
            >
              Let's Get Started
            </a>

            {/* Premium Active Features */}
            <div className={PricingPageStyle.activeFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .activeFeatures.json
              )}
            </div>

            {/* Premium Inactive Features */}
            <div className={PricingPageStyle.inactiveFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .inactiveFeatures.json
              )}
            </div>

            <hr />

            {/* Premium Active Ongoing Support */}
            <div className={PricingPageStyle.activeSupportDiv}>
              <h4>Ongoing Support</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .activeSupport.json
              )}
            </div>

            <hr />

            {/* Premium Add-on Features */}
            <div className={PricingPageStyle.addonFeaturesDiv}>
              <h4>Add-on Features</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .addOnFeatures.json
              )}
            </div>

            {/* Dessert Checkout */}
            <a
              href='https://app.firststringdigital.com/dessert-monthly'
              className={PricingPageStyle.choosePlanBtn3}
            >
              Let's Get Started
            </a>
          </div>
        </Col>
      </Row>
    )}
  />
);

export default MonthlyPricing;
